import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { GetAllPosts } from "../../apis/posts/get_all_posts";
import PostBox from "./post_box";
import PlaceHolder from "../../utils/placeholder";
import EditPostModal from "./edit_post";
import { GetSavedPosts } from "../../apis/posts/get_saved_posts";
import { GetArchivedPosts } from "../../apis/posts/get_arc_posts";

export default function ArchPostWrap() {
    const [PostData, setPostData] = useState([]);
    const [GetApi, setGetApi] = useState(API_STATUS);
    const [NoData, setNoData] = useState(false);
    const [edit, setEdit] = useState(false);
    const [editItem, setEditItem] = useState("");

    useEffect(() => {
        GetArchivedPosts(setGetApi);
    }, []);

    useEffect(() => {
        console.log(GetApi);
        if (!GetApi.isError && !GetApi.isLoader && GetApi.data != null) {
            let res = GetApi.data;
            if (res['status'] === 1) {
                if(res['data'].length === 0){
                    setNoData(true);
                }
                setPostData(res['data']);
            } else {
                setNoData(true);
            }
        }
    }, [GetApi]);


    return <div className="flex-1">
        {
            GetApi.isLoader &&
            <PlaceHolder />
        }
        {
            PostData != null && PostData.length > 0 && !edit &&
            <div className="xl:space-y-6 space-y-3">
                {
                    PostData.map((item, i) =>
                        <PostBox key={i} item={item} setEdit={setEdit} setEditItem={setEditItem} />
                    )
                }
            </div>
        }
        {
            edit &&
            <EditPostModal item={editItem} setEdit={setEdit} />
        }
        {
            NoData &&
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm dark:border-slate-700 dark:bg-dark2">

                <div className="relative md:gap-8 gap-4 items-center md:p-10 p-6">

                    <div className="flex-1">

                        <p className=" mt-1 font-normal">No posts found</p>
                    </div>
                </div>
            </div>
        }
    </div>
}